import React from "react";
import ReactDOM from "react-dom";
import MarketArchiveStockValue from "./containers/MarketArchiveStockValue";
import { getElementsProperty } from "../helpers/getElementsProperty";

export const initMarketArchiveStockValue = className => {
  getElementsProperty(className, (property, element) => {
    ReactDOM.render(<MarketArchiveStockValue symbol={property.symbol} />, element);
  });
};
